type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

const LinkedInLikeIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    strokeWidth = '1.5',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 10.5C3 9.95 3.45 9.5 4 9.5H7V20H4C3.45 20 3 19.55 3 19V10.5Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 9.5L11 2.5C12.1 2.5 13 3.4 13 4.5V8.5H20C21.1 8.5 22 9.4 21.8 10.5L20.3 18.7C20.15 19.45 19.45 20 18.7 20H7V9.5Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkedInLikeIcon;
